import { request, downloadRequest } from './request'
import { Methods } from './models'
import { BaseVue } from "@newview/base-web";
import { Vue } from "vue-property-decorator";
import Router from 'vue-router'
export abstract class netbaseApi {
  public Methods = Methods;
  public abstract get ProxyName()
  public abstract get ControllerName();

  public baseOption: any = { headers: {} };

  /**
   * 添加请求头
   * @param key 
   * @param value 
   */
  public addHeader(key, value) {
    this.baseOption.headers[key] = value;
  }

  /**
   * 设置SysGuid
   * @param value 
   */
  public setSysGuid(value) {
    this.addHeader("SysGuid", value);
  }

  public getUrl(methodName: string, controllerName: string = ''): string {
    controllerName = controllerName == '' ? this.ControllerName : controllerName;
    return `/${this.ProxyName}/${controllerName}/${methodName}`
  }
  /** 验证用户是否互斥登录  */ 
  private async validUserMutex() {
    if (sessionStorage.getItem('globalData') == null) return { issucess: true, msg: '不受控' };
    const _globalData: any = JSON.parse(sessionStorage.getItem('globalData')!);
    if (_globalData.localUser != null && _globalData.localUser != undefined && _globalData.localUser.IsMutex == 2) {
      let dats = await request("/SysApi/OAuth/LoginMutexValidate", { method: Methods.GET, params: { AId: _globalData.localUser.Id, LoginMToken: _globalData.localUser.PCLoginToken, systemType: 1 } });
      return dats.result;
    }
    else return { issucess: true, msg: '开放式' };
  }
  public send(data: any, methodName: string, method: Methods, controllerName: string = '', option: any = {}) {
    let transData = { data: data }
    let param = { params: data }
    let newOption = Object.assign(Object.assign({}, this.baseOption), option);
    let options = Object.assign({ method: method }, newOption)
    console.log('newOption',options)
    this.validUserMutex().then((rvalid) => {
      if (!rvalid.issucess) {
        let dlist: BaseVue = new BaseVue();
        dlist.alert(rvalid.msg, () => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace(window.document.location.origin);
        }, "warning", "异地登录验证提示");
      }
    });
    return request(this.getUrl(methodName, controllerName), method === Methods.GET ? Object.assign(options, param) : Object.assign(options, transData));
  }

  public sendDownload(data: any, methodName: string, method: Methods, fileName: string = '') {
    let transData = { data: data }
    let param = { params: data }
    let options = { method: method }
    return downloadRequest(this.getUrl(methodName), method === Methods.GET ? Object.assign(options, param) : Object.assign(options, transData), fileName)
  }

  /**
   * 获取SysGuid
   * @param roadSkey 
   * @returns 
   */
  public getSysGuid(roadSkey: string = "") {
    return roadSkey == "" ? sessionStorage.getItem("sysGuid") : roadSkey;
  }

  /**
   * 获取SysGuid Header
   * @param roadSkey 
   * @returns 
   */
  public getSysGuidHeader(roadSkey: string = "") {
    const sysGuid = this.getSysGuid(roadSkey);
    return { headers: { SysGuid: sysGuid } };
  }

  /**
   * 添加数据
   * @param formData
   */
  public insert(formData: any) {
    return this.send(formData, 'Insert', Methods.POST)
  }

  /**
   * 修改数据
   * @param formData
   */
  public update(formData: any) {
    return this.send(formData, 'Update', Methods.POST)
  }
  /**
   * 保存数据
   * @param formData
   */
  public save(formData: any) {
    return this.send(formData, 'Save', Methods.POST)
  }

  /**
   * 保存数据
   * @param formData json键值对
   */
  public saveDynamic(formData: any) {
    return this.send(formData, 'SaveDynamic', Methods.POST)
  }

  /**
   * 批量保存数据
   * @param formDatas json键值对数组
   */
  public saves(formDatas: any[]) {
    return this.send(formDatas, 'Saves', Methods.POST)
  }

  /**
   * 批量保存数据
   * @param formDatas json键值对数组
   */
  public saveTree(formDatas: any[]) {
    return this.send(formDatas, 'SaveBatchOfNode', Methods.POST)
  }

  /**
   * 删除节点并更新父节点的HasChild
   * @param formData 
   */
  public DelNodeAndUpHasChild(formData: any) {
    return this.send(formData, 'DelNodeAndUpHasChild', Methods.POST)
  }
  /**
   * 根据id获取实体对象
   * @param id
   */
  public getEntity(id: number) {
    return this.send({ id: id }, 'GetEntity', Methods.GET)
  }

  /**
   * 根据条件获取实体
   * @param filter 查询条件
   */
  public getEntityByFilter(filter: string) {
    return this.send({ filter: filter }, 'GetEntityByFilter', Methods.GET)
  }

  /**
   * 分页查询对象
   */
  public getEntitiesPage(pageIndex: number, pageSize: number, filter: string = ' 1 = 1 ', orderBy: string = ' Id asc ', option: any = {}) {
    const params = { pageIndex: pageIndex, pageSize: pageSize, filter: filter, orderBy: orderBy }
    return this.send(params, 'GetEntitiesPage', Methods.GET, this.ControllerName, option)
  }

  /**
   * 查询对象
   */
  public getEntities(filter: string = ' 1 = 1 ', orderBy: string = ' Id asc ', option: any = {}) {
    const params = { filter: filter, orderBy: orderBy }
    return this.send(params, 'GetEntities', Methods.GET, this.ControllerName, option)
  }

  /**
   * 分页查询数据，查询指定字段数据
   * @param pageIndex 
   * @param pageSize 
   * @param select 
   * @param filter 
   * @param orderBy 
   */
  public getEntitiesPageDynamic(pageIndex: number, pageSize: number, select: string = "*", filter: string = ' 1 = 1 ', orderBy: string = ' Id asc ', option: any = {}) {
    const params = { pageIndex: pageIndex, pageSize: pageSize, select: select, filter: filter, orderBy: orderBy }
    return this.send(params, 'GetEntitiesPageDynamic', Methods.GET, this.ControllerName, option)
  }

  /**
   * 根据条件查询数据
   * @param select 
   * @param filter 
   * @param orderBy 
   * @param groupBy 
   */
  public getEntitiesDynamic(select: string = "*", filter: string = ' 1 = 1 ', orderBy: string = ' Id asc ', groupBy: string = "", option: any = {}) {
    const params = { select: select, filter: filter, orderBy: orderBy, groupBy: groupBy }
    return this.send(params, 'GetEntitiesDynamic', Methods.GET, this.ControllerName, option)
  }

  /**
   * 拖拽排序
   * @param params
   */
  public dragOrderConPId(params) {
    return this.send(params, 'DragOrderConPId', Methods.GET)
  }
  /**
   * 根据Id删除数据
   * @param id
   */
  public delete(id: number) {
    return this.send({ id: id }, 'Delete', Methods.GET)
  }
  /**
   * 根据条件删除数据
   * @param id
   */
  public deleteByFilter(filter: string) {
    return this.send({ filter: filter }, 'DeleteByFilter', Methods.POST)
  }

  /**
   * 批量删除数据
   * @param ids
   */
  public batchDelete(ids: string) {
    return this.send({ ids: ids }, 'BatchDelete', Methods.POST)
  }

  /**
   * 获取记录条数
   * @param where 
   */
  public getRecordCount(where: string) {
    return this.send({ where }, 'GetRecordCount', this.Methods.GET);
  }

  /**
   * 批量获取记录条数
   * @param filters 
   */
  public getRecordCounts(filters: string[]) {
    return this.send(filters, 'GetRecordCounts', this.Methods.POST);
  }

  /**
   * 获取服务器时间
   * @returns 
   */
  public getServerTime() {
    return this.send({}, "GetServerTime", Methods.GET);
  }

}
